import React from "react";

import { CheckWildDark } from "@/components/icons/CheckWildDark";
import { Minus2 } from "@/components/icons/Minus2";
import { ButtonNova } from "@/components/ui-kit/ButtonNova/ButtonNova";
import Picture from "@/components/ui-kit/Picture/Picture";
import { TextElement } from "@/components/ui-kit/TextElement/TextElement";
import { useNavigation } from "@/hooks/useNavigation";
import { Column, ComparableItem } from "@/types/search";
import { cn } from "@/utils/general";

import { columns, comparableItems } from "./comparisondata";
import styles from "./ComparisonTable.module.scss";

const ComparisonTable: React.FC = () => {
  const navigate = useNavigation();

  return (
    <>
      <TextElement text="An overview of our formulas:" element="p" className="title--small" />

      <section className={cn("bg-[#f8f8f5] py-6 px-2")}>
        {/* Top Row: Items */}
        <div className={cn("flex justify-center gap-8")}>
          {comparableItems.map((item: ComparableItem) => (
            <article key={item.heading} className="text-center">
              <Picture src={item.imgsmall} alt={item.heading} />
              <ButtonNova
                level="Textlink"
                label={item.heading}
                className="mx-auto"
                onClick={() => navigate(item.link)}
              />
            </article>
          ))}
        </div>

        {/* Comparison Rows */}
        {columns.map((column: Column) => (
          <div className={cn("flex flex-wrap gap-[5px] mt-3")} key={column.text}>
            <div className={cn(styles.rowHeader, "text-master-primary-default")}>{column.text}</div>

            {column.rows.map((row, idx) => (
              <div className={styles.cell} key={`${row}-${idx}`}>
                {typeof row !== "number" ? (
                  <TextElement
                    text={String(row)}
                    className="text-master-base-black body--regular"
                    element="p"
                  />
                ) : row ? (
                  <CheckWildDark className="text-[#008078]" />
                ) : (
                  <Minus2 className="text-[#90A9A6]" />
                )}
              </div>
            ))}
          </div>
        ))}

        {/* Bottom Buttons */}
        <div className={cn("flex gap-2 mt-2")}>
          {comparableItems.map((item: ComparableItem) => (
            <div className="w-1/4" key={item.heading}>
              <ButtonNova
                level="Primary"
                label={item.buttonText}
                width="100%"
                onClick={() => navigate(item.buttonLink)}
              />
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default ComparisonTable;
